export const FEISHU_CLIENT_ID = process.env.VUE_APP_FEISHU_CLIENT_ID || 'cli_aa807ace3d38dcbd'
export const FEISHU_APP_ID = FEISHU_CLIENT_ID

const FEISHU_AUTHORIZE_URL = 'https://accounts.feishu.cn/open-apis/authen/v1/authorize'
const FEISHU_REDIRECT_URI = process.env.VUE_APP_FEISHU_REDIRECT_URI || 'http://127.0.0.1:8072/'

export function getFeishuAuthorizeUrl(clientId = FEISHU_CLIENT_ID, redirectUri = FEISHU_REDIRECT_URI) {
  const params = new URLSearchParams({
    client_id: clientId,
    response_type: 'code',
    redirect_uri: redirectUri,
  })

  return `${FEISHU_AUTHORIZE_URL}?${params.toString()}`
}

export function redirectToFeishuAuthorize() {
  window.location.href = getFeishuAuthorizeUrl()
}

export function isFeishuClient() {
  const userAgent = window.navigator.userAgent || ''
  return /feishu|lark/i.test(userAgent)
}

export function getFeishuAuthCode(routeQuery = {}) {
  const routeCode = Array.isArray(routeQuery.code) ? routeQuery.code[0] : routeQuery.code
  if (routeCode) return routeCode

  return new URLSearchParams(window.location.search).get('code')
}

export function clearFeishuAuthQuery() {
  const url = new URL(window.location.href)
  let hasAuthQuery = url.searchParams.has('code') || url.searchParams.has('state')

  url.searchParams.delete('code')
  url.searchParams.delete('state')

  if (url.hash.includes('?')) {
    const [hashPath, hashQuery] = url.hash.slice(1).split('?')
    const hashParams = new URLSearchParams(hashQuery)
    hasAuthQuery = hasAuthQuery || hashParams.has('code') || hashParams.has('state')
    hashParams.delete('code')
    hashParams.delete('state')
    const normalizedHashQuery = hashParams.toString()
    url.hash = normalizedHashQuery ? `${hashPath}?${normalizedHashQuery}` : hashPath
  }

  if (!hasAuthQuery) return

  window.history.replaceState(window.history.state, document.title, `${url.pathname}${url.search}${url.hash}`)
}
